import getHeaders from '../../helpers/headers'
import axios from 'axios'
import config from '../../../constants/endpoints.js'

const {
  endpoints: {
    plugins: {
      trackingUserHistory
    },
  },
} = config

/**
 * Get Tracking User Data
 *
 * @param {String} conversationId Conversation id
 * @param {Int} page page number
 * @param {Int} pageSize page size
*/
export const getTrackingNavigationHistory = ({ conversationId, page, pageSize }) => axios.post(
  trackingUserHistory, 
  {
    conversationId,
    page,
    pageSize
  },
  { headers: getHeaders(true) }
)
export default getTrackingNavigationHistory
